<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="e">
			<v-card-title>
				<span>Pranešimas #{{e["ID"]}}</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="form" class="mt-1">
					<table>
						<tr>
							<th>Autorius</th>
							<td>{{e["User"]}}</td>
						</tr>
						<tr>
							<th>Tipas</th>
							<td>{{e["TypePretty"]}}</td>
						</tr>
						<tr>
							<th>Reikšmė</th>
							<td>{{e["Value"]}}</td>
						</tr>
						<tr>
							<th>Pranešimas</th>
							<td>{{e["Message"]}}</td>
						</tr>
						<tr>
							<th>Sukurta</th>
							<td>{{e["CreateDate"]}}</td>
						</tr>
						<tr>
							<th>Redaguota</th>
							<td>{{e["UpdateDate"]}}</td>
						</tr>
					</table>
					<v-select
						label="Statusas"
						hide-details
						v-model="status"
						class="body-2 mt-5"
						:rules="rules"
						:items="statusItems"
						item-value="key"
						item-text="name"
						:key="getKey('status')"
					></v-select>
				</v-form>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="save"
					outlined
					small
					:loading="saveInAction"
				>
					Išsaugoti
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="saveInAction"
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import AdminHelper from "../helpers/AdminHelper";

	export default {
		data: function(){
			var data = {
				dialog: false,
				saveInAction: false,
				e: null,
				status: null,
				iteration: 0,
				rules: [v => !!v || "Laukas privalomas"],
				statusItems: [{
					key: "submitted",
					name: AdminHelper.getAttributeTitle("submitted") // Reikšmė?
				},{
					key: "inProgress",
					name: AdminHelper.getAttributeTitle("inProgress") // Reikšmė?
				},{
					key: "approved",
					name: AdminHelper.getAttributeTitle("approved") // Reikšmė?
				},{
					key: "rejected",
					name: AdminHelper.getAttributeTitle("rejected") // Reikšmė?
				},{
					key: "closed",
					name: AdminHelper.getAttributeTitle("closed") // Reikšmė?
				}],
			};
			return data;
		},
		created: function(){
			this.$vBus.$on("show-user-message", this.showDialog);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-user-message", this.showDialog);
		},
		methods: {
			closeDialog: function(){
				this.e = null;
				this.dialog = false;
			},
			showDialog: function(e){
				this.iteration += 1;
				this.e = e;
				this.status = this.e["Status"];
				this.dialog = true;
			},
			save: function(){
				var formValid = this.$refs.form.validate();
				if (formValid) {
					this.saveInAction = true;
					var params = {
						id: this.e["ID"],
						status: this.status
					};
					var def = AdminHelper.updateUserMessage(params);
					def.then(function(){
						this.saveInAction = false;
						this.dialog = false;
						this.e["Status"] = this.status; // Sinchronizuojame reikšmę sąraše... FIXME! Negalima taip tiesiogiai keisti reikšmės!!???
						// TODO: reikia atnaujinti ir bendrame sąraše...
					}.bind(this), function(){
						this.$vBus.$emit("show-message", "error");
						this.saveInAction = false;
					}.bind(this));
				}
			},
			getKey: function(key){
				key = key + "-" + this.iteration;
				return key;
			}
		}
	}
</script>

<style scoped>
	table {
		border-collapse: collapse;
	}
	td, th {
		border: 1px solid #cccccc;
		text-align: left;
		padding: 7px;
	}
	.v-select {
		width: 300px;
	}
</style>